import { Row, Col, Form, Input, Divider, Select, Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import accountService from "../../../api/account.service";
import { FORM_NAME_COMPONENT_DETAILS_ADMISSION, SUCCESS_STATUS } from "../../../utility/Constants";
import commonUtility from "../../../utility/Utils";
const { Option } = Select;


function EnrollmentComponent(props) {
  const { onAmountChange } = props;
  const [cgstList, setCgstList] = useState([]);
  const [sgstList, setSgstList] = useState([]);
  const [formDetailKeyName, setFormDetailKeyName] = useState("");
  const [isWaiverRequired, setIsWaiverRequired] = useState(false);
  const [waiverSelectedList, setWaiverSelectedList] = useState([]);

  // take discount backup edit by dipten (12.02.2025)
  const [discountBackup, setDiscountBackup] = useState(0)
  
  // console.log("waiverSelectedList", waiverSelectedList);
  // console.log("asdagdas", props.enrollmentForm.getFieldValue());
  useEffect(() => {
    if (props.admissionComponents && props.admissionComponents.length > 0) {
  
      // console.log("asdagdas", props.enrollmentForm.getFieldValue());
      // console.log("admissionComponents", props.admissionComponents);
    }
  }, [props.admissionComponents]);

  useEffect(() => {
    if (props.progCommercialCompMonthlyList && props.progCommercialCompMonthlyList.length > 0) {
      // console.log("progenrollment", props.progCommercialCompMonthlyList);
    }
  }, [props.progCommercialCompMonthlyList]);

  useEffect(() => {
    const data = {
      formdata: { gstType: "CGST", usedfor: "I" },
    };
    accountService.gstListByInputType(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setCgstList(res.data.response_data);
      }
    });
  }, []);

  useEffect(() => {
    const data = {
      formdata: { gstType: "SGST", usedfor: "I" },
    };
    accountService.gstListByInputType(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setSgstList(res.data.response_data);
      }
    });
  }, []);



  useEffect(() => {
    setFormDetailKeyName(props.detailInputKey)
  }, [formDetailKeyName]);

  // if discount in noting set it 0 ---edit by dipten (12.02.2025)
  const handleblur=(e,i)=>{
    const discounts=e.target.value
    const discount = props.enrollmentForm.getFieldValue([
      formDetailKeyName,
      i,
      "discount",
    ]);
    if(!commonUtility.sanitizeValue(discount)){
      props.enrollmentForm.setFields([
        {
          name: [formDetailKeyName, i, "discount"],
          value: 0,
        },
      ]);
    }
  }

  const onDiscountChange = (e, i) => {
    //const indexValue = e.target.attributes.index.value;
    const discounts = e.target.value;
    const discount = props.enrollmentForm.getFieldValue([
      formDetailKeyName,
      i,
      "discount",
    ]);
    const admission_amount = props.enrollmentForm.getFieldValue([
      formDetailKeyName,
      i,
      "amount",
    ]);

    // check if discount is greater than amount ---edit by dipten (12.02.2025)
    if(commonUtility.sanitizeValue(discount) > commonUtility.sanitizeValue(admission_amount)){
      props.enrollmentForm.setFields([
        {
          name: [formDetailKeyName, i, "discount"],
          value: discountBackup,
        },
      ]);
      commonUtility.openNotificationWithType("error", "bottomRight", "Error", "Discount cannot be greater than amount");
      return;
    }else{
      setDiscountBackup(discounts)
    }
    const taxable_value = commonUtility.sanitizeValue(admission_amount) - commonUtility.sanitizeValue(discount);
    // props.setDiscountAmount(discounts);
    props.enrollmentForm.setFields([
      {
        name: [formDetailKeyName, i, "taxable_amount"],
        value: taxable_value,
      },
    ]);
    //calulatePayable(i);

    const cgst_rate = props.enrollmentForm.getFieldValue([formDetailKeyName, i, "cgst_rate"])
    const sgst_rate = props.enrollmentForm.getFieldValue([formDetailKeyName, i, "sgst_rate"])


    onSelectCGST(e, "OTHER", i, cgst_rate)
    onSelectSGST(e, "OTHER", i, sgst_rate)

  };

  const onSelectCGST = (e, tag, i, rate) => {
    let indexValue = 0;
    let rateValue = 0;

    if (tag == "DROPDOWN") {
      indexValue = e.index
      rateValue = e.rate
    }
    else {
      indexValue = i
      rateValue = rate
    }


    const taxable = props.enrollmentForm.getFieldValue([
      formDetailKeyName,
      indexValue,
      "taxable_amount",
    ]);
    props.enrollmentForm.setFields([
      {
        name: [formDetailKeyName, indexValue, "cgst_amount"],
        value: (taxable * rateValue) / 100,
      },
      {
        name: [formDetailKeyName, indexValue, "cgst_rate"],
        value: rateValue,
      },
    ]);
    calulateTotalGST(indexValue);
    calulatePayable(indexValue);


  };

  const onSelectSGST = (e, tag, i, rate) => {

    let indexValue = 0;
    let rateValue = 0;

    if (tag == "DROPDOWN") {
      indexValue = e.index
      rateValue = e.rate
    }
    else {
      indexValue = i
      rateValue = rate
    }


    const taxable = props.enrollmentForm.getFieldValue([
      formDetailKeyName,
      indexValue,
      "taxable_amount",
    ]);
    props.enrollmentForm.setFields([
      {
        name: [formDetailKeyName, indexValue, "sgst_amount"],
        value: (taxable * rateValue) / 100,
      },
      {
        name: [formDetailKeyName, indexValue, "sgst_rate"],
        value: rateValue,
      },
    ]);
    calulateTotalGST(indexValue);
    calulatePayable(indexValue);

  };


  const calulateTotalGST = (i) => {

    const cgst_amount = commonUtility.sanitizeValue(
      props.enrollmentForm.getFieldValue([
        formDetailKeyName,
        i,
        "cgst_amount",
      ])
    );
    const sgst_amount = commonUtility.sanitizeValue(
      props.enrollmentForm.getFieldValue([
        formDetailKeyName,
        i,
        "sgst_amount",
      ])
    );



    const total_gst = parseFloat(cgst_amount) + parseFloat(sgst_amount);

    props.enrollmentForm.setFields([
      {
        name: [formDetailKeyName, i, "total_gst_amount"],
        value: total_gst.toFixed(2),
      },
    ]);
  };


  const calulatePayable = (i) => {
    const taxable_amount = commonUtility.sanitizeValue(
      props.enrollmentForm.getFieldValue([
        formDetailKeyName,
        i,
        "taxable_amount",
      ])
    );
    const cgst_amount = commonUtility.sanitizeValue(
      props.enrollmentForm.getFieldValue([
        formDetailKeyName,
        i,
        "cgst_amount",
      ])
    );
    const sgst_amount = commonUtility.sanitizeValue(
      props.enrollmentForm.getFieldValue([
        formDetailKeyName,
        i,
        "sgst_amount",
      ])
    );



    const total_payable = taxable_amount + cgst_amount + sgst_amount;

    props.enrollmentForm.setFields([
      {
        name: [formDetailKeyName, i, "net_amount"],
        value: total_payable.toFixed(2),
      },
    ]);
  };


  const onChangeWaiver = (e) => {
    // console.log("Event Value ", e)
    // return false;
    const waiverValue = e.value;
    const i = e.index;


    //if(e.target.checked){
    if (waiverValue == "Y") {

      //document.getElementById("component_details_monthly_1_discount").readOnly = true;
      document.getElementById(`${formDetailKeyName}_${i}_discount`).readOnly = true;

      setWaiverSelectedList([...waiverSelectedList, {
        [i]: i,
        amount: props.enrollmentForm.getFieldValue([formDetailKeyName, i, "amount",]),
        discount: props.enrollmentForm.getFieldValue([formDetailKeyName, i, "discount",]),
        taxable_amount: props.enrollmentForm.getFieldValue([formDetailKeyName, i, "taxable_amount",]),
        cgst_id: props.enrollmentForm.getFieldValue([formDetailKeyName, i, "cgst_id",]),
        cgst_rate: props.enrollmentForm.getFieldValue([formDetailKeyName, i, "cgst_rate",]),
        cgst_rate_text: props.enrollmentForm.getFieldValue([formDetailKeyName, i, "cgst_rate_text",]),

        cgst_amount: props.enrollmentForm.getFieldValue([formDetailKeyName, i, "cgst_amount",]),
        sgst_id: props.enrollmentForm.getFieldValue([formDetailKeyName, i, "sgst_id",]),
        sgst_rate: props.enrollmentForm.getFieldValue([formDetailKeyName, i, "sgst_rate",]),
        sgst_rate_text: props.enrollmentForm.getFieldValue([formDetailKeyName, i, "sgst_rate_text",]),
        sgst_amount: props.enrollmentForm.getFieldValue([formDetailKeyName, i, "sgst_amount",]),
        total_gst_amount: props.enrollmentForm.getFieldValue([formDetailKeyName, i, "total_gst_amount",]),
        net_amount: props.enrollmentForm.getFieldValue([formDetailKeyName, i, "net_amount",]),
        due_amount: props.enrollmentForm.getFieldValue([formDetailKeyName, i, "due_amount",]),
      }]);



      props.enrollmentForm.setFields([
        {
          name: [formDetailKeyName, i, "amount"],
          value: 0,
        },
        {
          name: [formDetailKeyName, i, "discount"],
          value: 0,
        },
        {
          name: [formDetailKeyName, i, "taxable_amount"],
          value: 0,
        },
        {
          name: [formDetailKeyName, i, "cgst_id"],
          value: 0,
        },
        {
          name: [formDetailKeyName, i, "cgst_rate"],
          value: 0,
        },
        {
          name: [formDetailKeyName, i, "cgst_rate_text"],
          value: 0,
        },
        {
          name: [formDetailKeyName, i, "cgst_amount"],
          value: 0,
        },
        {
          name: [formDetailKeyName, i, "sgst_id"],
          value: 0,
        },
        {
          name: [formDetailKeyName, i, "sgst_rate"],
          value: 0,
        },
        {
          name: [formDetailKeyName, i, "sgst_rate_text"],
          value: 0,
        },
        {
          name: [formDetailKeyName, i, "sgst_amount"],
          value: 0,
        },
        {
          name: [formDetailKeyName, i, "total_gst_amount"],
          value: 0,
        },
        {
          name: [formDetailKeyName, i, "net_amount"],
          value: 0,
        },
        {
          name: [formDetailKeyName, i, "due_amount"],
          value: 0,
        },
        {
          name: [formDetailKeyName, i, "is_waiver"],
          value: 'Y',
        },
      ]);



    }
    else {
      document.getElementById(`${formDetailKeyName}_${i}_discount`).readOnly = false;
      waiverSelectedList.map((waverselectedlist, index) => {
        const keyslist = Object.keys(waverselectedlist);
        // console.log("keylist", keyslist)
        if (keyslist[0] == i) {

          // console.log("Amount List ", waverselectedlist.amount)

          props.enrollmentForm.setFields([
            {
              name: [formDetailKeyName, i, "amount"],
              value: waverselectedlist.amount,
            },
            {
              name: [formDetailKeyName, i, "discount"],
              value: waverselectedlist.discount,
            },
            {
              name: [formDetailKeyName, i, "taxable_amount"],
              value: waverselectedlist.taxable_amount,
            },
            {
              name: [formDetailKeyName, i, "cgst_id"],
              value: waverselectedlist.cgst_id,
            },
            {
              name: [formDetailKeyName, i, "cgst_rate_text"],
              value: waverselectedlist.cgst_rate_text,
            },
            {
              name: [formDetailKeyName, i, "cgst_rate"],
              value: waverselectedlist.cgst_rate,
            },
            {
              name: [formDetailKeyName, i, "cgst_amount"],
              value: waverselectedlist.cgst_amount,
            },
            {
              name: [formDetailKeyName, i, "sgst_id"],
              value: waverselectedlist.sgst_id,
            },
            {
              name: [formDetailKeyName, i, "sgst_rate"],
              value: waverselectedlist.sgst_rate,
            },
            {
              name: [formDetailKeyName, i, "sgst_rate_text"],
              value: waverselectedlist.sgst_rate_text,
            },
            {
              name: [formDetailKeyName, i, "sgst_amount"],
              value: waverselectedlist.sgst_amount,
            },
            {
              name: [formDetailKeyName, i, "net_amount"],
              value: waverselectedlist.net_amount,
            },
            {
              name: [formDetailKeyName, i, "total_gst_amount"],
              value: waverselectedlist.total_gst_amount,
            },
            {
              name: [formDetailKeyName, i, "due_amount"],
              value: waverselectedlist.due_amount,
            },
            {
              name: [formDetailKeyName, i, "is_waiver"],
              value: 'N',
            },
          ]);

        }
      })



    }



    props.onFormCalculation()

  };

  const [dueAmounts, setDueAmounts] = useState([]);
  // console.log('Received dueAmount:', props);
  // console.log("dueAmounts", dueAmounts);

  useEffect(() => {

    if (Array.isArray(props.progCommercialCompMonthlyList)) {

      const initialDueAmounts = props.progCommercialCompMonthlyList.map(month => month.amount || 0);
      setDueAmounts(initialDueAmounts);
    }
  }, [props.progCommercialCompMonthlyList]);

  useEffect(() => {
    if (props.dueAmount !== undefined && props.dueAmount >= 0) {
      let remainingPaid = props.dueAmount;
      const updatedDueAmounts = dueAmounts.map(due => {
        if (remainingPaid > 0) {
          if (remainingPaid >= due) {
            remainingPaid -= due;
            return 0;
          } else {
            const dueAfterPayment = due - remainingPaid;
            remainingPaid = 0;
            return dueAfterPayment;
          }
        } else {
          return due;
        }
      });

      setDueAmounts(updatedDueAmounts);
    }
  }, [props.dueAmount]);

  useEffect(() => {
    if (typeof onAmountChange === 'function') {
      onAmountChange(props.progCommercialCompMonthlyList);
    }
  }, [props.progCommercialCompMonthlyList]);

  const handleAmountChange = (event, index) => {
    if (typeof onAmountChange === 'function') {
      const updatedList = [...props.progCommercialCompMonthlyList];
      updatedList[index].amount = event.target.value;
      updatedList[index].isAmountDifferent = event.target.value !== props.progCommercialCompMonthlyList[index]?.amount;
      onAmountChange(updatedList);
    }
  };

  // console.log("isMonthlyComponentRender", props.isMonthlyComponentRender);
  // console.log("setProgCommercialCompMonthlyList", props.progCommercialCompMonthlyList);
  // const initialDueAmount = props.shortAdjustmentData?.due_amount || 0;

  return (
    <div>
      {props.admissionComponents && (
        <Form.List name={props.detailInputKey}>

          {(fields) => (
            <>
              {fields.map(({ key, name, ...restField }, index) => {

                return (
                  <div key={key}>
                    <Row
                      key={key}
                      style={{
                        display: "flex",
                        marginBottom: 8,
                        borderBottom: "0px solid red",
                      }}
                      align="baseline"
                      gutter={15}
                    >
                      <Col xs={24} xl={4}>
                        <Form.Item
                          {...restField}
                          name={[name, "description"]}
                          label="Description"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>

                        <Form.Item {...restField} name={[name, "component_id"]} hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item {...restField} name={[name, "month_id"]} hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item {...restField} name={[name, "year"]} hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item {...restField} name={[name, "cr_ac_id"]} hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "amount"]}
                          label="Amount"
                        >
                          <Input
                            placeholder=""
                            readOnly={true}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "discount"]}
                          label="Discount"
                        >
                          <Input
                            placeholder=""
                            index={index}
                            
                            // handle blur at 64 line ---edit by dipten (12.02.2025)
                            onBlur={(event)=>handleblur(event,index)}
                            onChange={(event) => onDiscountChange(event, index)}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "taxable_amount"]}
                          label="Taxable"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "cgst_id"]}
                          label="CGST"
                          hidden={true}
                        >
                          <Select
                            className="text-left"
                            defaultValue="Select"
                            onSelect={(value, event) => onSelectCGST(event, "DROPDOWN", 0, 0)}
                          >
                            {cgstList.length > 0
                              ? cgstList.map((cgst_list) => (
                                <Option
                                  key={cgst_list.id}
                                  value={cgst_list.id}
                                  index={index}
                                  rate={cgst_list.rate}
                                >
                                  {cgst_list.gstDescription}
                                </Option>
                              ))
                              : ""}
                          </Select>
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, "cgst_rate_text"]}
                          label="CGST"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>

                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "cgst_amount"]}
                          label="CGST Amt"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                        <Form.Item {...restField} name={[name, "cgst_rate"]} hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "sgst_id"]}
                          label="SGST"
                          hidden={true}
                        >
                          <Select
                            className="text-left"
                            defaultValue="Select"
                            onSelect={(value, event) => onSelectSGST(event, "DROPDOWN", 0, 0)}
                          >
                            {sgstList.length > 0
                              ? sgstList.map((sgst_list) => (
                                <Option
                                  key={sgst_list.id}
                                  value={sgst_list.id}
                                  index={index}
                                  rate={sgst_list.rate}
                                >
                                  {sgst_list.gstDescription}
                                </Option>
                              ))
                              : ""}
                          </Select>
                        </Form.Item>
                        <Form.Item {...restField} name={[name, "sgst_rate"]} hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "sgst_rate_text"]}
                          label="SGST"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "sgst_amount"]}
                          label="SGST Amt"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                        <Form.Item {...restField} name={[name, "total_gst_amount"]} hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "net_amount"]}
                          label="Payable"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={2} hidden={true}>
                        <Form.Item
                          {...restField}
                          name={[name, "due_amount"]}
                          value="0"
                          label="Due"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>


                      <Col xs={24} xl={2} >
                        <Form.Item
                          {...restField}
                          name={[name, "is_waiver"]}
                          label="Waive"
                        >
                          <Select
                            className="text-left"
                            defaultValue="N"
                            onSelect={(value, event) => onChangeWaiver(event)}
                          >
                            <Option value="N" index={index}>No</Option>
                            <Option value="Y" index={index}>Yes</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>

                    <Divider style={{ margin: 2 }} />
                  </div>
                );
              })}
            </>
          )}
        </Form.List>
      )}
      {props.progCommercialCompMonthlyList && (
        <Form.List name={props.detailInputKey}>

          {(fields) => (
            <>
              {fields.map(({ key, name, ...restField }, index) => {
                // console.log("fields", props.progCommercialCompMonthlyList[0]);
                const isAmountDifferent = props.progCommercialCompMonthlyList[index]?.isAmountDifferent;

                return (
                  <div key={key}>
                    <Row
                      key={key}
                      style={{
                        display: "flex",
                        marginBottom: 8,
                        borderBottom: "0px solid red",
                        backgroundColor: isAmountDifferent ? '#fff1f0' : 'transparent',
                      }}
                      align="baseline"
                      gutter={15}
                    >
                      <Col xs={24} xl={4}>
                        <Form.Item
                          {...restField}
                          name={[name, "description"]}
                          label="Description"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>

                        <Form.Item {...restField} name={[name, "component_id"]} hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item {...restField} name={[name, "month_id"]} hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item {...restField} name={[name, "year"]} hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item {...restField} name={[name, "cr_ac_id"]} hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "amount"]}
                          label="Amount"
                        >
                          <Input
                            placeholder=""
                            readOnly={true}
                            style={{
                              color: isAmountDifferent ? '#f51707' : 'inherit',
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "discount"]}
                          label="Discount"
                        >
                          <Input
                            placeholder=""
                            index={index}
                            onChange={(event) => onDiscountChange(event, index)}
                            readOnly={isAmountDifferent}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "taxable_amount"]}
                          label="Taxable"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "cgst_id"]}
                          label="CGST"
                          hidden={true}
                        >
                          <Select
                            className="text-left"
                            defaultValue="Select"
                            onSelect={(value, event) => onSelectCGST(event, "DROPDOWN", 0, 0)}
                          >
                            {cgstList.length > 0
                              ? cgstList.map((cgst_list) => (
                                <Option
                                  key={cgst_list.id}
                                  value={cgst_list.id}
                                  index={index}
                                  rate={cgst_list.rate}
                                >
                                  {cgst_list.gstDescription}
                                </Option>
                              ))
                              : ""}
                          </Select>
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, "cgst_rate_text"]}
                          label="CGST"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>

                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "cgst_amount"]}
                          label="CGST Amt"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                        <Form.Item {...restField} name={[name, "cgst_rate"]} hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "sgst_id"]}
                          label="SGST"
                          hidden={true}
                        >
                          <Select
                            className="text-left"
                            defaultValue="Select"
                            onSelect={(value, event) => onSelectSGST(event, "DROPDOWN", 0, 0)}
                          >
                            {sgstList.length > 0
                              ? sgstList.map((sgst_list) => (
                                <Option
                                  key={sgst_list.id}
                                  value={sgst_list.id}
                                  index={index}
                                  rate={sgst_list.rate}
                                >
                                  {sgst_list.gstDescription}
                                </Option>
                              ))
                              : ""}
                          </Select>
                        </Form.Item>
                        <Form.Item {...restField} name={[name, "sgst_rate"]} hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "sgst_rate_text"]}
                          label="SGST"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "sgst_amount"]}
                          label="SGST Amt"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                        <Form.Item {...restField} name={[name, "total_gst_amount"]} hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "net_amount"]}
                          label="Payable"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={2}>
                        <Form.Item
                          {...restField}
                          name={[name, "due_amount"]}
                          label="Due"
                          initialValue={0}
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>


                      <Col xs={24} xl={2} >
                        <Form.Item
                          {...restField}
                          name={[name, "is_waiver"]}
                          label="Waive"
                        >
                          <Select
                            className="text-left"
                            defaultValue="N"
                            onSelect={(value, event) => onChangeWaiver(event)}
                            disabled={isAmountDifferent}
                          >
                            <Option value="N" index={index}>No</Option>
                            <Option value="Y" index={index}>Yes</Option>
                          </Select>
                        </Form.Item>
                      </Col>

                    </Row>

                    {isAmountDifferent && (
                      <div style={{ color: '#f51707', marginTop: -10, marginBottom: 8 }}>
                        Error: Amount has been changed of the above month, you can't include this month into the list.
                      </div>
                    )}

                    {/* {props.errorMessage && (
                      <div className="error-message" style={{ color: 'red', marginBottom: '10px' }}>
                        {props.errorMessage}
                      </div>
                    )} */}

                    <Divider style={{ margin: 2 }} />
                  </div>
                );
              })}
            </>
          )}
        </Form.List>
      )}
    </div>
  );
}

export default EnrollmentComponent;
